import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "px-6 py-4 border-b border-gray-700 flex justify-between items-center" }
const _hoisted_2 = { class: "flex items-center space-x-3" }
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = { class: "text-xs text-gray-400" }
const _hoisted_5 = {
  key: 0,
  class: "px-6 py-3 bg-red-900 bg-opacity-50 border-b border-gray-700 text-sm text-red-300"
}
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = {
  key: 1,
  class: "px-6 py-3 border-b border-gray-700 bg-gray-750"
}
const _hoisted_8 = { class: "grid grid-cols-2 gap-3 text-sm" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-center text-blue-400"
}
const _hoisted_10 = {
  key: 1,
  class: "flex items-center text-green-400"
}
const _hoisted_11 = {
  key: 2,
  class: "flex items-center text-orange-400"
}
const _hoisted_12 = {
  key: 3,
  class: "flex items-center text-yellow-400"
}
const _hoisted_13 = {
  key: 2,
  class: "px-6 py-3 border-b border-gray-700 flex justify-between items-center bg-gray-750"
}
const _hoisted_14 = { class: "text-sm text-gray-400" }
const _hoisted_15 = { class: "flex space-x-2" }
const _hoisted_16 = { class: "max-h-96 overflow-y-auto" }
const _hoisted_17 = {
  key: 0,
  class: "px-6 py-12 text-center text-gray-400"
}
const _hoisted_18 = { class: "divide-y divide-gray-700" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "flex items-start space-x-4" }
const _hoisted_21 = { class: "flex-shrink-0 mt-1" }
const _hoisted_22 = { class: "text-lg" }
const _hoisted_23 = { class: "flex-1 min-w-0" }
const _hoisted_24 = { class: "text-sm font-medium text-white mb-1" }
const _hoisted_25 = { class: "text-sm text-gray-300 mb-2 line-clamp-2" }
const _hoisted_26 = { class: "flex items-center justify-between" }
const _hoisted_27 = { class: "text-xs text-gray-500" }
const _hoisted_28 = { class: "flex items-center space-x-2" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 3,
  class: "px-6 py-3 border-t border-gray-700 text-center bg-gray-750"
}
const _hoisted_32 = { class: "text-xs text-gray-400" }

import { useNotifications } from '@/composables/useNotifications';

interface Props {
  show: boolean;
  isSidebarOpen: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationDropdown',
  props: {
    show: { type: Boolean },
    isSidebarOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

// Use notifications composable
const {
  notifications,
  badges,
  unreadCount,
  totalBadgeCount,
  isConnected,
  connectionError,
  markAsRead,
  markAllAsRead,
  removeNotification,
  clearAllNotifications,
  handleNotificationClick,
  formatTime,
  getNotificationTitle,
  getNotificationMessage,
  getNotificationIconClass,
  forceReconnect,
} = useNotifications();

// Get notification icon
const getNotificationIcon = (type: string) => {
  const icons = {
    new_message: '💬',
    user_follow: '👤',
    product_follow: '❤️',
    product_expired: '⏰',
    new_rating: '⭐',
  };
  return icons[type as keyof typeof icons] || '🔔';
};

return (_ctx: any,_cache: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-50 flex items-center justify-center",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm" }, null, -1)),
        _createElementVNode("div", {
          class: "relative bg-gray-800 rounded-lg shadow-2xl border border-gray-700 w-full max-w-md mx-4 max-h-[90vh] overflow-hidden",
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-xl font-semibold text-white" }, "Obaveštenja", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", {
                  class: _normalizeClass(["w-2 h-2 rounded-full", {
                'bg-green-500': _unref(isConnected),
                'bg-red-500': !_unref(isConnected) && _unref(connectionError),
                'bg-yellow-500': !_unref(isConnected) && !_unref(connectionError),
              }])
                }, null, 2),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(isConnected) ? 'Online' : 'Offline'), 1)
              ]),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                class: "text-gray-400 hover:text-white transition-colors p-1 rounded-full hover:bg-gray-700"
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("svg", {
                  class: "w-5 h-5",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ]))
            ])
          ]),
          (!_unref(isConnected) && _unref(connectionError))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[8] || (_cache[8] = _createElementVNode("svg", {
                    class: "w-4 h-4 mr-2",
                    fill: "currentColor",
                    viewBox: "0 0 20 20"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                      "clip-rule": "evenodd"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(connectionError)) + " ", 1),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(forceReconnect) && _unref(forceReconnect)(...args))),
                    class: "ml-2 text-xs underline hover:no-underline"
                  }, " Pokušaj ponovo ")
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(totalBadgeCount) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_unref(badges).messages > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "w-3 h-3 bg-blue-500 rounded-full mr-2" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(badges).messages) + " poruka", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(badges).follows > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "w-3 h-3 bg-green-500 rounded-full mr-2" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(badges).follows) + " praćenja", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(badges).products > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "w-3 h-3 bg-orange-500 rounded-full mr-2" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(badges).products) + " proizvoda", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(badges).ratings > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "w-3 h-3 bg-yellow-500 rounded-full mr-2" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(badges).ratings) + " ocena", 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(notifications).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(notifications).length) + " obaveštenja", 1),
                _createElementVNode("div", _hoisted_15, [
                  (_unref(unreadCount) > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(markAllAsRead) && _unref(markAllAsRead)(...args))),
                        class: "text-sm text-blue-400 hover:text-blue-300 transition-colors px-2 py-1 rounded hover:bg-gray-700"
                      }, " Označi sve kao pročitano "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(clearAllNotifications) && _unref(clearAllNotifications)(...args))),
                    class: "text-sm text-red-400 hover:text-red-300 transition-colors px-2 py-1 rounded hover:bg-gray-700"
                  }, " Obriši sve ")
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            (_unref(notifications).length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[13] || (_cache[13] = [
                  _createElementVNode("svg", {
                    class: "w-16 h-16 mx-auto mb-4 text-gray-600",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    })
                  ], -1),
                  _createElementVNode("p", { class: "text-lg font-medium mb-2" }, "Nema obaveštenja", -1),
                  _createElementVNode("p", { class: "text-sm" }, " Kada budete imali nova obaveštenja, pojaviće se ovde. ", -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications).slice(0, 20), (notification) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: notification.id,
                  onClick: ($event: any) => (_unref(handleNotificationClick)(notification)),
                  class: _normalizeClass(["notification-item px-6 py-4 hover:bg-gray-700 cursor-pointer transition-all duration-200", {
              'bg-blue-900 bg-opacity-20 border-l-4 border-l-blue-500':
                !notification.read,
              'bg-gray-800': notification.read,
            }])
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-10 h-10 rounded-full flex items-center justify-center", _unref(getNotificationIconClass)(notification.type)])
                      }, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(getNotificationIcon(notification.type)), 1)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(getNotificationTitle)(notification)), 1),
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(getNotificationMessage)(notification)), 1),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(formatTime)(notification.createdAt)), 1),
                        _createElementVNode("div", _hoisted_28, [
                          (!notification.read)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _withModifiers(($event: any) => (_unref(markAsRead)(notification.id)), ["stop"]),
                                class: "text-blue-400 hover:text-blue-300 text-xs px-2 py-1 rounded hover:bg-gray-600 transition-colors"
                              }, " Označi kao pročitano ", 8, _hoisted_29))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            onClick: _withModifiers(($event: any) => (_unref(removeNotification)(notification.id)), ["stop"]),
                            class: "text-red-400 hover:text-red-300 text-xs px-2 py-1 rounded hover:bg-gray-600 transition-colors"
                          }, " Ukloni ", 8, _hoisted_30)
                        ])
                      ])
                    ])
                  ])
                ], 10, _hoisted_19))
              }), 128))
            ])
          ]),
          (_unref(notifications).length > 20)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("p", _hoisted_32, " Prikazano " + _toDisplayString(Math.min(20, _unref(notifications).length)) + " od " + _toDisplayString(_unref(notifications).length) + " obaveštenja ", 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})